exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icons[data-v-7c219744]{margin-right:10px;opacity:.5}.btn-space[data-v-7c219744]{width:100%}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/input/index.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,UAAa,CACd,AACD,4BACE,UAAY,CACb","file":"index.vue","sourcesContent":["\n.icons[data-v-7c219744] {\n  margin-right: 10px;\n  opacity: 0.5;\n}\n.btn-space[data-v-7c219744] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c219744","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/input/index.vue
// module id = 811
// module chunks = 3 41 43 44